export const appInfo = {
  versionType: import.meta.env.VITE_VERSION_TYPE,
  fullName: import.meta.env.VITE_FULL_NAME,
  shortCut: import.meta.env.VITE_SHORTCUT_NAME,
  icon: import.meta.env.VITE_ICON,
};

export const authConfig = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL,
    key: import.meta.env.VITE_SUPABASE_KEY,
  },
};
